function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_aktiv",
  "data-name": "Icon aktiv",
  transform: "translate(243.414 0.372)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Linie_97",
  "data-name": "Linie 97",
  y1: 20,
  x2: 12,
  transform: "translate(-234 1)",
  fill: "none",
  stroke: "#008cd6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_107",
  "data-name": "Linie 107",
  x2: 8,
  y2: 8,
  transform: "translate(-242 13)",
  fill: "none",
  stroke: "#008cd6",
  strokeLinecap: "round",
  strokeWidth: 2
}));

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.786,
    height: 22.786,
    viewBox: "0 0 22.786 22.786",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.59596aaf.svg";
export { ForwardRef as ReactComponent };